import axios from "axios";

// In production the React application and the API are served by the same
// HTTPS origin. A separate URL can still be supplied for local development.
const BASE = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");
export const API = `${BASE}/api`;

// A sessão fica num cookie HttpOnly (o navegador envia sozinho); o cabeçalho
// X-Requested-With prova ao servidor que o pedido saiu do próprio site.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "lumine" },
});

export const SESSION_HINT_KEY = "lumine_signed_in";
export const LEGACY_TOKEN_KEY = "lumine_token";

export const ADMIN_MFA_KEY = "lumine_admin_mfa";

const readAdminMfa = () => {
  try { return sessionStorage.getItem(ADMIN_MFA_KEY) || ""; } catch { return ""; }
};

api.interceptors.request.use((cfg) => {
  // Admin routes also carry the second-factor session (kept only for this tab).
  if (String(cfg.url || "").startsWith("/admin")) {
    const mfa = readAdminMfa();
    if (mfa) cfg.headers["X-Admin-MFA"] = mfa;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (["PLAN_TRANSACTION_LIMIT", "PLAN_USERS_LIMIT", "ROLE_FORBIDDEN"].includes(err?.response?.data?.detail?.code)) {
      // As telas exibem o "detail" direto na mensagem de erro; aqui ele vira texto.
      err.response.data.detail = err.response.data.detail.message;
    }
    if (err?.response?.status === 402 && err?.response?.data?.detail?.code === "SUBSCRIPTION_REQUIRED") {
      if (!window.location.pathname.startsWith("/assinar")) window.location.href = "/assinar";
    }
    const code = err?.response?.data?.detail?.code;
    if (err?.response?.status === 403 && (code === "ADMIN_MFA_REQUIRED" || code === "ADMIN_MFA_SETUP_REQUIRED")) {
      try { sessionStorage.removeItem(ADMIN_MFA_KEY); } catch { /* ignore */ }
      window.dispatchEvent(new CustomEvent("lumine:admin-mfa-required", { detail: code }));
    }
    if (err?.response?.status === 401) {
      try {
        localStorage.removeItem(LEGACY_TOKEN_KEY);
        localStorage.removeItem(SESSION_HINT_KEY);
        localStorage.removeItem("lumine_session_cache");
      } catch { /* storage unavailable */ }
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// Shares one GET between components that ask for the same data at nearly the
// same time (e.g. the dashboard starts a request that a child component will
// need, so both don't wait in sequence).
const sharedRequests = new Map();
export function getShared(url, params = {}, ttlMs = 5000) {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));
  const key = `${url}?${JSON.stringify(clean)}`;
  const hit = sharedRequests.get(key);
  if (hit && Date.now() - hit.at < ttlMs) return hit.promise;
  const promise = api.get(url, { params: clean });
  sharedRequests.set(key, { at: Date.now(), promise });
  promise.catch(() => sharedRequests.delete(key));
  return promise;
}
